var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card-seplag',{attrs:{"titulo":_vm.campos && _vm.campos.length > 0 && _vm.campos[0].descQuestionario ? _vm.campos[0].descQuestionario : 'Questionário padrão',"cor":"#00acc1","cols":_vm.cols}})}
var staticRenderFns = []

export { render, staticRenderFns }